import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';
import { useClientChecker } from '../client-checker';

const componentName = 'split-page';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        textVariant: {
            type: [Boolean, String],
            default: false
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        const client = useClientChecker();
        const textVariant = ctx.props.textVariant.toString() == 'true';

        return h(
            'div', {
                class: [
                    'split-page__wrapper',
                    { 'split-page__wrapper--text': textVariant },
                    ctx.data.staticClass
                ],
            }, [
                h('main', { class: 'split-page__main-wrapper' }, [
                    h('div', { class: 'split-page__main' }, [
                        h('div', { class: 'split-page__content-wrapper' }, [
                            ctx.slots().default,
                            ctx.slots().beforecontent && h('div', { class: 'split-page__before-content' }, [
                                ctx.slots().beforecontent
                            ]),
                            ctx.slots().content && h('div', { class: 'split-page__content' }, [
                                ctx.slots().content
                            ]),
                            ctx.slots().aftercontent && h('div', { class: 'split-page__after-content' }, [
                                ctx.slots().aftercontent
                            ])
                        ])
                    ])
                ]),
                h('div', { class: 'split-page__identity' }, [
                    h('img', { attrs: { src: appropriateIdentitySrc(client) }})
                ])
            ]
        )
    }
}

function appropriateIdentitySrc(client: any) {
    const isToolbox: boolean = client.clientIsToolbox.value;
    const isYesly: boolean = client.clientIsYesly.value || client.clientIsGoogleYesly.value || client.clientIsAlexaYesly.value;
    const isBliss: boolean = client.clientIsBliss.value || client.clientIsBliss2.value || client.clientIsGoogleBliss.value || client.clientIsAlexaBliss.value;

    if (isToolbox) {
        return '/images/logo-toolbox-nfc-white.svg';
    }
    else if (isYesly) {
        return '/images/logo-yesly-white.svg';
    }
    else if (isBliss) {
        return '/images/logo-bliss-white.svg';
    }
    else {
        return '/images/logo-finder-white.svg';
    }
}